export const FETCH_LICENSE_FORMS_INIT = 'FETCH_LICENSE_FORMS_INIT';
export const FETCH_LICENSE_FORMS_DONE = 'FETCH_LICENSE_FORMS_DONE';
export const FETCH_LICENSE_FORMS_FAIL = 'FETCH_LICENSE_FORMS_FAIL';
